<template>
    <div>
        <div class="top-right">
            <div class="search-word">
                搜索热词：
                <span
                    v-for="(word,index) in searchWords"
                    :key="index"
                    @click="toSearch(word.name)"
                >{{word.name}}</span>
            </div>
            <div class="search">
                <div class="search-input">
                    <el-input
                        placeholder="请输入内容"
                        v-model="searchinput"
                        prefix-icon="el-icon-search"
                        class="input-with-select"
                    >
                        <el-button slot="append" @click="toSearch(searchinput)">文章</el-button>
                        <el-button slot="append" @click="toExpert">专家</el-button>
                    </el-input>
                </div>
                <div class="head-login" v-if="!loginState">
                    <div class="btn login" @click="dialogShow('login')">登录</div>
                    <div class="btn" @click="dialogShow('register')">注册</div>
                </div>
                <div class="head-login" v-else>
                    <div class="avatar" @click="gotopersonalcenter()">
                        <img :src="userInfo.avatar" alt />
                    </div>
                    <div class="user">
                        <div class="user-message">
                            <div class="message" @click="goCenter('systemshow')">
                                <i class="el-icon-message-solid"></i>
                                <div class="num">{{userInfo.noticenum}}</div>
                            </div>
                            <div class="message" @click="goCenter('messageshow')">
                                <i class="el-icon-s-comment"></i>
                                <div class="num">{{userInfo.msgnum}}</div>
                            </div>
                        </div>
                        <div class="user-name" @click="gotopersonalcenter()">{{userInfo.nickname}}</div>
                    </div>
                    <i class="el-icon-switch-button" title="退出" @click="outLogin"></i>
                </div>
            </div>
        </div>
        <login ref="login"></login>
    </div>
</template>

<script>
    // 必须引用
    import Login from './Login';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: { Login },
        data() {
            return {
                searchWords: [],
                searchinput: ''
            };
        },
        computed: {
            ...mapGetters(['loginState', 'userInfo'])
        },
        created() {
            this.getLoginStatus();
            this.getHotWord();
        },
        methods: {
            ...mapActions(['getLoginStatus']),
            outLogin() {
                this.$confirm('确定退出登录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$store.commit('setToken', '');
                        this.$store.commit('setUserInfo', '');
                        this.$store.commit('setLoginState', 0);
                        this.$message({
                            type: 'success',
                            message: '已退出登录!'
                        });
                        this.$router.replace('Welcome');
                    })
                    .catch(() => {});
            },
            goCenter(name) {
                this.$router.push({
                    name: 'personal-center',
                    query: {
                        type: name
                    }
                });
            },
            gotopersonalcenter() {
                this.$router.push({
                    name: 'personal-center'
                });
            },
            getHotWord() {
                this.httpGet(this.$root.getHotWords, {})
                    .then(result => {
                        this.searchWords.push(...result);
                    })
                    .catch(err => {
                        console.error('getHotWords-err', err);
                    });
            },
            toExpert() {
                if (this.searchinput == '') {
                    this.$message({
                        message: '请输入搜索内容',
                        type: 'error'
                    });
                    return;
                }
                this.$router.push({
                    name: 'expert-base',
                    query: {
                        name: this.searchinput
                    }
                });
            },
            toSearch(name) {
                // alert(this.searchinput);
                if (name == '') {
                    this.$message({
                        message: '请输入搜索内容',
                        type: 'error'
                    });
                    return;
                }
                this.$router.push({
                    name: 'station-search',
                    query: {
                        name: name
                    }
                });
            },
            dialogShow(type) {
                if (type == 'login') {
                    this.$refs.login.toLog();
                } else {
                    this.$refs.login.toRegister();
                }
            }
        },
        watch: {
            '$store.state.login.token': function() {
                if (!this.$store.state.login.token) {
                    this.getLoginStatus();
                }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .top-right {
        width: 100%;
        height: 88px;
        flex-y(center, flex-start);
        margin-top: 40px;

        .search-word {
            width: 100%;
            flex-x(flex-start);
            height: 17px;
            font-size: 12px;
            color: white;
            line-height: 17px;
            margin-bottom: 6px;

            span {
                margin-right: 15px;
            }
        }

        .search-word:hover {
            cursor: pointer;
        }

        .search {
            width: 100%;
            flex-x();

            .search-input {
                width: 75%;
            }

            .input-with-select {
                width: 100%;

                >>>.el-input__inner {
                    width: 100%;
                    height: 40px;
                    border: 0px solid white;
                    background: rgba(255, 255, 255, 0.3);
                    border-radius: 4px 0px 0px 4px;
                    color: white !important;
                }

                >>>.el-input {
                    width: 80%;
                    color: white !important;
                }

                >>>.el-input-group__append {
                    background: none;
                    border: 0px solid white;
                    padding: 0;

                    .el-button {
                        width: 56px;
                        height: 40px;
                        background: rgba(25, 124, 254, 1);
                        border-radius: 0px 4px 4px 0px;
                        color: white;
                        text-align: center;
                        padding: 0;
                        margin: 0;
                        margin-left: 2px;
                    }
                }
            }

            .head-login {
                flex-x(flex-start);
                width: 35%;
                height: 40px;

                .btn {
                    width: 72px;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.45);
                    border-radius: 4px;
                    border: 1px solid rgba(25, 124, 254, 1);
                    margin-left: 8px;
                    flex-center();
                    color: #4093FF;
                    font-size: 16px;

                    &.login {
                        background: #197CFE;
                        color: white;
                    }
                }

                .btn:hover {
                    cursor: pointer;
                }

                .avatar {
                    cursor: pointer;
                    width: 40px;
                    height: 100%;
                    border-radius: 4px;
                    margin: 0 8px;

                    img {
                        height: 100%;
                        width: 100%;
                        border-radius: 4px;
                    }
                }

                .user {
                    width: calc(100% - 90px);
                    height: 100%;
                    flex-y(center, space-between);

                    .user-message {
                        flex-x(space-between);
                        height: 45%;

                        .message {
                            position: relative;
                            width: 16px;
                            height: 16px;
                            cursor: pointer;

                            i {
                                font-size: 16px;
                                color: white;
                            }

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            .num {
                                min-width: 14px;
                                max-width: 24px;
                                height: 14px;
                                background: rgba(255, 89, 92, 1);
                                border-radius: 15px;
                                color: white;
                                font-size: 8px;
                                line-height: 12px;
                                text-align: center;
                                padding: 0 2px;
                                position: absolute;
                                right: -10px;
                                top: -6 px;
                                ellipsis();
                            }
                        }
                    }

                    .user-name {
                        cursor: pointer;
                        height: 45%;
                        width: 100%;
                        color: white;
                        font-size: 14px;
                        ellipsis();
                    }
                }

                .el-icon-switch-button {
                    font-size: 24px;
                    color: white;
                    margin-left: 6px;
                }

                .el-icon-switch-button:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>
